import React from 'react';
import Api from '../../api/Api.js';
import StatsEndpoints from '../../api/StatsEndpoints';

import _ from 'lodash';

import { connect } from 'react-redux';

import Datetime from "react-datetime";

import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";

import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import Loading from '../Loading/Loading';
import Empty from '../Empty/Empty';
import moment from 'moment';
import { store } from '../../redux/store';
import { SET_STATS } from '../../redux/types';

class StatsWrapper extends React.Component {

    constructor(props) {
        super(props);

        if (!props.data) {
            const hasData = this.checkIfHasData(props.allStats[props.name]);

            this.state = {
                hasData,
                loading: !hasData,
                failed: false,
                data: hasData ? props.allStats[props.name] : null,
                start: props.start || moment().startOf('month').startOf('day'),
                end: props.end || moment().endOf('month').endOf('day'),
                loadingOverlay: false
            }
        }
        else {
            const hasData = this.checkIfHasData(props.data);

            this.state = {
                hasData,
                loading: !hasData,
                failed: false,
                data: hasData ? props.data : null,
                start: props.start || moment().startOf('month'),
                end: props.end || moment().endOf('month'),
                loadingOverlay: false
            }
        }
    }

    checkIfHasData(data) {
        if (_.isArray(data))
            return data.length > 0;

        if (typeof (data) === 'object')
            return _.some(data);

        if (typeof (data) == 'undefined' || typeof (data) == 'function' || typeof (data) === 'symbol')
            return false;
        else
            return true;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!_.isEqual(nextProps.data, this.props.data)) {

            const hasData = this.checkIfHasData(nextProps.data);

            var newState = {
                hasData,
                failed: false,
                data: hasData ? nextProps.data : null
            }

            this.setState(newState);
        } else if (!nextProps.data && (nextProps.name != this.props.name || !_.isEqual(nextProps.allStats[nextProps.name], this.props.allStats[this.props.name]))) {
            const hasData = this.checkIfHasData(nextProps.allStats[nextProps.name]);

            var newnewState = {
                hasData,
                failed: false,
                data: hasData ? nextProps.allStats[nextProps.name] : null
            }

            this.setState(newnewState);
        }
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        Api[this.props.post ? "post" : (this.props.get ? "get" : this.props.method)](StatsEndpoints[this.props.name], { start: this.state.start, end: this.state.end, ...this.props.params })
            .then((response) => {
                if (response) {
                    var { data } = response;
                    this.setState({ hasData: this.checkIfHasData(data), loading: false, failed: false, data, loadingOverlay: false },
                        () => store.dispatch({ type: SET_STATS, name: this.props.name + (this.props.id ? "-" + this.props.id : ""), payload: data }));
                } else {
                    this.setState({ hasData: false, loading: false, failed: true, loadingOverlay: false });
                }
            })
            .catch((e) => {
                this.setState({ loading: false, failed: true, hasData: false, loadingOverlay: false });
                console.error(e);
            })
    }

    renderDateRanges() {

        const { classes } = this.props;

        return (
            <GridContainer key="dateRanges">
                <GridItem xs={12} sm={12} md={5}>
                    <FormControl fullWidth>
                        <Datetime
                            dateFormat="YYYY-MM-DD"
                            timeFormat={false}
                            inputProps={{ disabled: false, placeholder: "Start Date", type: 'text', className: 'form-control ' + classes.datetimeInput, style: { fontSize: 14, textAlign: 'center' } }}
                            onChange={(value) => {
                                if (moment(value).isValid()) {
                                    if (moment(value).add(this.props.limitMonths || 3, 'months').isBefore(moment(this.state.end))) {
                                        this.props.snackbar(false,
                                            <span>So Sorry...<br />
                                                The statistics have been limited to {this.props.limitMonths || 3} months.</span>,
                                            "danger",
                                            'tc'
                                        )
                                        this.setState({ start: moment(value).startOf('day') });
                                    }
                                    else if (moment(value).isAfter(this.state.end)) {
                                        this.setState({ start: moment(value).startOf('day') });
                                    }
                                    else {
                                        this.props.snackbar(true,
                                            <span>So Sorry...<br />
                                                The statistics have been limited to {this.props.limitMonths || 3} months.</span>,
                                            "danger",
                                            'tc'
                                        )
                                        this.setState({ start: moment(value).startOf('day'), loadingOverlay: true }, () => this.refresh());
                                    }

                                }
                            }}
                            value={this.state.start}
                        />
                    </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={2} style={{ textAlign: 'center', marginTop: 10, marginBottom: 20 }}><KeyboardArrowRight style={{ fontSize: 32 }} /></GridItem>
                <GridItem xs={12} sm={12} md={5}>
                    <FormControl fullWidth>
                        <Datetime
                            dateFormat="YYYY-MM-DD"
                            timeFormat={false}
                            inputProps={{ disabled: false, placeholder: "End Date", type: 'text', className: 'form-control ' + classes.datetimeInput, style: { fontSize: 14, textAlign: 'center' } }}
                            onChange={(value) => {
                                if (moment(value).isValid()) {
                                    if (
                                        moment(value).subtract(this.props.limitMonths || 3, 'months').isAfter(moment(this.state.start))
                                    ) {
                                        this.props.snackbar(false,
                                            <span>So Sorry...<br />
                                                The statistics have been limited to {this.props.limitMonths || 3} months.</span>,
                                            "danger",
                                            'tc'
                                        );
                                        this.setState({ end: moment(value).endOf('day') })
                                    }
                                    else if (moment(value).isBefore(this.state.start)) {
                                        this.setState({ end: moment(value).endOf('day') })
                                    }
                                    else {
                                        this.props.snackbar(true,
                                            <span>So Sorry...<br />
                                                The statistics have been limited to {this.props.limitMonths || 3} months.</span>,
                                            "danger",
                                            'tc'
                                        )
                                        this.setState({ end: moment(value).endOf('day'), loadingOverlay: true }, () => this.refresh());
                                    }
                                }
                            }}
                            value={this.state.end}
                        />
                    </FormControl>
                </GridItem>
            </GridContainer>
        );
    }

    renderChildren() {
        const { children } = this.props;
        const childrenWithProps = React.Children.map(children, child => React.cloneElement(child, { data: this.state.data }));
        return childrenWithProps;
    }

    render() {
        return (
            <div style={{ position: 'relative', ...this.props.style }} className={this.props.className} {...this.props.wrapperProps}>
                {
                    this.state.loading ?
                        <Loading />
                        :
                        (
                            this.state.hasData ?
                                [
                                    (this.props.hideDatePicker ? null : this.renderDateRanges()),
                                    this.renderChildren(),
                                    (this.state.loadingOverlay ? <Loading key="loading" overlay /> : null)
                                ]
                                :
                                (
                                    this.state.failed ?
                                        <h3>Error</h3>
                                        :
                                        <div style={{ textAlign: 'center' }}>
                                            {this.props.hideDatePicker ? null : this.renderDateRanges()}
                                            <div style={{ fontWeight: 'bold' }}><Empty title='Sorry... No stats to show' /></div>
                                        </div>
                                )
                        )
                }
            </div>
        );
    }
}

const styles = {

}

const mapStateToProps = (state) => {
    return {
        allStats: state.stats
    };
}

export default withStyles({ ...extendedFormsStyle, ...styles })(connect(mapStateToProps)(StatsWrapper))